import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterItem } from '@app-model/side-filter-options';
import { UniversalStorage } from '@aws-amplify/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class SideFilterService {
	private toogleSidePanelFilterSource = new BehaviorSubject<boolean>(false);
	toogleSidePanelFilter = this.toogleSidePanelFilterSource.asObservable();

	private _dontRenderFilterSource = new BehaviorSubject<any[]>([]);
	dontRenderFilter = this._dontRenderFilterSource.asObservable();

	constructor(private _http: HttpClient) {}

	// initFilterPane() {}

	// initFilter(filterCompanies?: string) {}

	// getCompanies(name?: string): Observable<UserCompany[]> {}

	changeToogleSidePanelFilterSource(status: boolean, config?) {
		if (!status) {
			this.updateDontRenderList([]);
		} else if (config) {
			this.updateDontRenderList(config);
		}
		this.toogleSidePanelFilterSource.next(status);
	}

	updateDontRenderList(config) {
		this._dontRenderFilterSource.next(config);
	}

	loadVacinnes(): Observable<FilterItem[]> {
		let vaccines: FilterItem[] = [];

		return this._http.get(`${environment.api}/dashboard/vaccines`).pipe(
			map((response: any) => {
				response.forEach((v: any) => {
					let item: FilterItem = { label: v.title, value: v.id };
					vaccines.push(item);
				});

				return vaccines;
			})
		);
	}

	getCompanyMatrizIds() {
		var companyIds = [];
		var universalStorage = new UniversalStorage();
		if (universalStorage.getItem('filterLastCompanyMatrizId')) {
			companyIds = universalStorage.getItem('filterLastCompanyMatrizId').split(',');
		}
		return companyIds;
	}

	getCompanyIds() {
		var companyIds = [];
		var universalStorage = new UniversalStorage();
		if (universalStorage.getItem('filterLastCompanyId')) {
			companyIds = universalStorage.getItem('filterLastCompanyId').split(',');
		}
		return companyIds;
	}

	getCompanyById(companyId) {
		return this._http.get(`${environment.api}/configurations/getCompanyById/${companyId}`).pipe(
			map((response: any) => {
				if (Array.isArray(response)) {
					return response.sort(function (a, b) {
						return a.companyName.toUpperCase() > b.companyName.toUpperCase()
							? 1
							: b.companyName.toUpperCase() > a.companyName.toUpperCase()
							? -1
							: 0;
					});
				}
				return response;
			})
		);
	}
	// public getCompanyByIdMaster(companyId) {}

	// excludeFieldsFilterByCompany(companies, uniqueCompany, companyIdNode) {}
}
